import {IDropdownItem} from "@retail-data-factory/rdf-angular-types-components";


export const simpleList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'Да', name: 'Да'},
  {code: 'Нет', name: 'Нет'}];


export const typeArticlesList: Array<IDropdownItem> = [
  {code: "0", name: ""},
  {code: "1", name: "Свежие продукты"},
  {code: "2", name: "Электротовары"},
  {code: "3", name: "Другие"}
];

export const ndsRateList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: '10', name: '10'},
  {code: '18', name: '18'}, //Нужен? для совместимости со старыми артикулами
  {code: '20', name: '20'},
  {code: '0', name: '0'},
  {code: 'Без НДС', name: 'Без НДС'},
  //{code: '-1', name: ''}
];

export const fromCountryList: Array<IDropdownItem> = [
  {code: '0', name: '--'},
  {code: '1', name: 'Россия'},
  {code: '2', name: 'Другая'}];

export const buyUnitList: Array<IDropdownItem> = [
  {code: '0', name: ''},
  {code: '1', name: 'шт'},
  {code: '2', name: 'кг'},
  {code: '3', name: 'л'},
  {code: '4', name: 'м'},
  {code: '5', name: 'кв.м'}];

export const saleUnitList: Array<IDropdownItem> = [
  {code: '0', name: ''},
  {code: '1', name: 'шт'},
  {code: '2', name: 'кг'},
  {code: '3', name: 'л'},
  {code: '4', name: 'м'},
  {code: '5', name: 'кв.м'}];

export const characteristicsProductList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'MN (НМ)', name: 'MN (НМ)'},
  {code: 'MP (СМА)', name: 'MP (СМА)'},
  {code: 'PO (1ЦПА)', name: 'PO (1ЦПА)'},
  {code: 'PP (1Ц)', name: 'PP (1Ц)'}];


export const productTypeList: Array<IDropdownItem> = [
  {code: '0', name: ''},
  {code: '1', name: 'Обычный ФК'},
  {code: '2', name: 'Обычный ИК'},
  {code: '3', name: 'Сырье ИК'},
  {code: '4', name: 'Сырье ФК'}];

export const articleStatusList: Array<IDropdownItem> = [
  {code: "AC", name: "AC"},
  {code: "AS", name: "AS"},
  {code: "SE", name: "SE"},
  {code: "NC", name: "NC"},
  {code: "NV", name: "NV"},
  {code: "PA", name: "PA"},
  {code: "AN", name: "AN"},
  {code: "PS", name: "PS"},
  {code: "NA", name: "NA"},
  {code: "NN", name: "NN"},
  {code: "SA", name: "SA"},
  {code: "SN", name: "SN"}];

export const auchanProdList: Array<IDropdownItem> =  [
  {code: "КД", name: "КД"},
  {code: "EPRI", name: "EPRI"},
  {code: "MDD", name: "MDD"},
  {code: "MDDI", name: "MDDI"},
  {code: "КП", name: "КП"},
  {code: "ЗП", name: "ЗП"},
  {code: "ПЦ", name: "ПЦ"},
  {code: "ПЦИ", name: "ПЦИ"},
  {code: "КПИ", name: "КПИ"},
  {code: "ЗПИ", name: "ЗПИ"},
  {code: "NNI", name: "NNI"}];

export const regionList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'БЕЗ ПРИЗНАКА', name: 'БЕЗ ПРИЗНАКА'},
  {code: 'ГРАППА МОСКВА', name: 'ГРАППА МОСКВА'},
  {code: 'ГРАППА ПЕТЕРБУРГ', name: 'ГРАППА ПЕТЕРБУРГ'},
  {code: 'ГРАППА СИБИРЬ', name: 'ГРАППА СИБИРЬ'},
  {code: 'ГРАППА УРАЛ', name: 'ГРАППА УРАЛ'},
  {code: 'ГРАППА ЮГ', name: 'ГРАППА ЮГ'},
  {code: 'ГРАППА ВОЛГА', name: 'ГРАППА ВОЛГА'},
  {code: 'РЕГИОН', name: 'РЕГИОН'},
  {code: 'АРЗАМАС', name: 'АРЗАМАС'},
  {code: 'БАЛАШОВ', name: 'БАЛАШОВ'},
  {code: 'БАРНАУЛ', name: 'БАРНАУЛ'},
  {code: 'БЕЛГОРОД', name: 'БЕЛГОРОД'},
  {code: 'ВЛАДИМИР', name: 'ВЛАДИМИР'},
  {code: 'ВОЛГОГРАД', name: 'ВОЛГОГРАД'},
  {code: 'ВОЛОГДА', name: 'ВОЛОГДА'},
  {code: 'ВОРОНЕЖ', name: 'ВОРОНЕЖ'},
  {code: 'ГУБКИН', name: 'ГУБКИН'},
  {code: 'ЕКАТЕРИНБУРГ', name: 'ЕКАТЕРИНБУРГ'},
  {code: 'ИВАНОВО', name: 'ИВАНОВО'},
  {code: 'ИЖЕВСК', name: 'ИЖЕВСК'},
  {code: 'КАЗАНЬ', name: 'КАЗАНЬ'},
  {code: 'КАЛУГА', name: 'КАЛУГА'},
  {code: 'КЛИН', name: 'КЛИН'},
  {code: 'КОВРОВ', name: 'КОВРОВ'},
  {code: 'КОСТРОМА', name: 'КОСТРОМА'},
  {code: 'КОЛОМНА', name: 'КОЛОМНА'},
  {code: 'КРАСНОДАР', name: 'КРАСНОДАР'},
  {code: 'КРАСНОЯРСК', name: 'КРАСНОЯРСК'},
  {code: 'КУЗНЕЦК', name: 'КУЗНЕЦК'},
  {code: 'КУРСК', name: 'КУРСК'},
  {code: 'ЛИПЕЦК', name: 'ЛИПЕЦК'},
  {code: 'МАГНИТОГОРСК', name: 'МАГНИТОГОРСК'},
  {code: 'МОСКВА', name: 'МОСКВА'},
  {code: 'НИЖНИЙ НОВГОРОД', name: 'НИЖНИЙ НОВГОРОД'},
  {code: 'НОВОКУЗНЕЦК', name: 'НОВОКУЗНЕЦК'},
  {code: 'НОВОСИБИРСК', name: 'НОВОСИБИРСК'},
  {code: 'ОМСК', name: 'ОМСК'},
  {code: 'ПЕНЗА', name: 'ПЕНЗА'},
  {code: 'ПЕРМЬ', name: 'ПЕРМЬ'},
  {code: 'РОСТОВ', name: 'РОСТОВ'},
  {code: 'РЯЗАНЬ', name: 'РЯЗАНЬ'},
  {code: 'САМАРА', name: 'САМАРА'},
  {code: 'САНКТ ПЕТЕРБУРГ', name: 'САНКТ ПЕТЕРБУРГ'},
  {code: 'САРАНСК', name: 'САРАНСК'},
  {code: 'САРАТОВ', name: 'САРАТОВ'},
  {code: 'СТАРЫЙ ОСКОЛ', name: 'СТАРЫЙ ОСКОЛ'},
  {code: 'ТАМБОВ', name: 'ТАМБОВ'},
  {code: 'ТВЕРЬ', name: 'ТВЕРЬ'},
  {code: 'ТУЛА', name: 'ТУЛА'},
  {code: 'ТЮМЕНЬ', name: 'ТЮМЕНЬ'},
  {code: 'УЛЬЯНОВСК', name: 'УЛЬЯНОВСК'},
  {code: 'УФА', name: 'УФА'},
  {code: 'ЧЕЛЯБИНСК', name: 'ЧЕЛЯБИНСК'},
  {code: 'ЮЖНЫЙ', name: 'ЮЖНЫЙ'},
  {code: 'ЯРОСЛАВЛЬ', name: 'ЯРОСЛАВЛЬ'},
  {code: 'ЯХРОМА', name: 'ЯХРОМА'}
];

export const vegetarianList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'Веганский', name: 'Веганский'},
  {code: 'Вегетарианский', name: 'Вегетарианский'},
  {code: 'Нет', name: 'Нет'}
];

//PILOT VRS
export const simpleBooleanList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'true', name: 'Да'},
  {code: 'false', name: 'Нет'}];

export const baseUnitList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'м', name: 'м'},
  {code: 'шт', name: 'шт'},
  {code: 'кг', name: 'кг'},
  {code: 'пара', name: 'пара'},
  {code: 'л', name: 'л'}];

export const ndsRatePercentList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: '10%', name: '10%'},
  {code: 'Без НДС', name: 'Без НДС'},
  {code: '20%', name: '20%'}
 ,
];

export const shellLifePeriodList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'Час', name: 'Час'},
  {code: 'День', name: 'День'},
  {code: 'Неделя', name: 'Неделя'},
  {code: 'Месяц', name: 'Месяц'},
  {code: 'Год', name: 'Год'}];

export const precenseModeList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'Постоянный', name: 'Постоянный'},
  {code: 'Сезонный', name: 'Сезонный'},
  {code: 'In Out', name: 'In Out'}
];

export const outputScriptList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'Возврат поставщику', name: 'Возврат поставщику'},
  {code: 'Коммерческий остаток (хранение на РЦ)', name: 'Коммерческий остаток (хранение на РЦ)'},
  {code: 'Утилизация (через списание)', name: 'Утилизация (через списание)'},
  {code: 'Продажа в аутлет (через списание)', name: 'Продажа в аутлет (через списание)'}
];

export const deliveryUnitList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'ГМ', name: 'ГМ'},
  {code: 'ММ', name: 'ММ'},
  {code: 'РЦ', name: 'РЦ'}
];

export const typeAlcoholList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'Бренди', name: 'Бренди'},
  {code: 'Вино', name: 'Вино'},
  {code: 'Винный напиток', name: 'Винный напиток'}
];

export const typeProductList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'Живые животные', name: 'Живые животные'},
  {code: 'Корма и кормовые добавки', name: 'Корма и кормовые добавки'},
  {code: 'Лекарственные средства', name: 'Лекарственные средства'},
  {code: 'Мясо и мясопродукты', name: 'Мясо и мясопродукты'},
];

export const typeExpertList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'Продукция подвергнута ВСЭ в полном объеме', name: 'Продукция подвергнута ВСЭ в полном объеме'},
  {code: 'ВСЭ подвергнуто сырьё, из которого произведена продукция', name: 'ВСЭ подвергнуто сырьё, из которого произведена продукция'}
];

export const typeStorageList: Array<IDropdownItem> = [
  {code: '', name: ''},
  {code: 'Охлажденные', name: 'Охлажденные'},
  {code: 'Замороженные', name: 'Замороженные'},
  {code: 'Вентилируемые', name: 'Вентилируемые'},
  {code: 'Охлаждаемый', name: 'Охлаждаемый'}
];
